import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { env } from "@/config/env";
import { FIRESTORE_DATABASE_ID, STORAGE_BUCKET_URL } from "@/config/firebase.constants";

const firebaseConfig = {
  apiKey: env.firebase.apiKey,
  authDomain: env.firebase.authDomain,
  projectId: env.firebase.projectId,
  storageBucket: env.firebase.storageBucket,
  messagingSenderId: env.firebase.messagingSenderId,
  appId: env.firebase.appId,
  measurementId: env.firebase.measurementId
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const firestore = getFirestore(firebaseApp, FIRESTORE_DATABASE_ID);
export const storage = getStorage(firebaseApp, STORAGE_BUCKET_URL);
export const functions = getFunctions(firebaseApp, env.firebase.region);
